import { createBrowserHistory } from 'history';
import { getCoreInterface } from './contexts/coreInterface';
import { root } from './routes';

let history;

export default (basename = root) => {
  if (history) {
    return history;
  }

  history = createBrowserHistory({ basename });

  history.root = basename;

  // extend history object to do navigation from the external router
  history.loadUrl = url => {
    history.replace(url.replace(basename, ''));

    return history;
  }; // will remove root from the url

  history.unlisten = history.listen(() => {
    /**
     * Triggers module:navigate, so that Core-UI knows that the module has internally re-routed
     * Currently this is used (or planned to be used) for the following things:
     * 1) Updating the active highlight in the navigation
     * 2) Analytics tracking
     */
    const coreInterface = getCoreInterface();
    if (coreInterface) {
      coreInterface.triggerGlobalEvent('module:navigate');
    }
  });

  return history;
};
